module.exports = __webpack_public_path__ + "img/huan.c4aedbc8.png";